import { IconButton, Tooltip } from '@dixa/lib-shared-habla';

import type { SidebarCardId } from 'components/conversation/components/sidebar/conversationSidebar.types';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';

import { useCardVisibility } from '../../hooks/useCardVisibility';

type VisibilityToggleProps = {
  cardId: SidebarCardId;
};

export const VisibilityToggle = ({
  cardId,
}: VisibilityToggleProps): JSX.Element | null => {
  const { hiddenCards, toggleCardVisibility } = useCardVisibility();
  const flags = useFeatureFlag(['conversation-right-sidebar-visibility']);

  const isHidden = hiddenCards.has(cardId);

  return flags.conversationRightSidebarVisibility ? (
    <Tooltip content={isHidden ? 'Show card' : 'Hide card'}>
      <IconButton
        icon={isHidden ? 'eye-slash' : 'eye'}
        variant="tertiary"
        onClick={(event) => {
          event.stopPropagation();
          toggleCardVisibility(cardId);
        }}
      />
    </Tooltip>
  ) : null;
};
